module.exports = __webpack_public_path__ + "img/AISI.8f81af70.png";